module.exports = __webpack_public_path__ + "static/media/S_S02.fba99b4c.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/RED/S_S02.png
// module id = 136
// module chunks = 0